export const PAYMENT_STATUS_KEY = (residentId: string): string =>
  `PAYMENT_STATUS-${residentId}`;
